import { useQuery } from "react-query";

import { getAllEmlakjetProperties } from "../utils/api";
import { dedupeListings } from "../utils/dedupeListings";

const useEmlakjetProperties = () => {
  const { data, isLoading, isError, refetch } = useQuery(
    ["allProperties", "deduped-v2"],
    getAllEmlakjetProperties,
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
    }
  );

  return {
    data: dedupeListings(data),
    isError,
    isLoading,
    refetch,
  };
};

export default useEmlakjetProperties;
